import React, { useRef, useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import SweetAlert2 from 'react-sweetalert2';
import DatosCabezaFamilia from '../DatosCabezaFamilia.jsx';
import { NavLink, useParams } from 'react-router-dom';
import apiService from '../../../Auth/apiService.jsx';
import { useAuth } from '../../../Auth/AuthContext.jsx';

export default function CargarCedula() {
    const { idCabezaFamilia } = useParams();
	const { token, user } = useAuth();
	const fileRef = useRef(null);
	const [Cargando, setCargando] = useState(false);
	const [selectedFile, setSelectedFile] = useState(null);
	const [swalProps, setSwalProps] = useState({});
    const [integrantes, setIntegrantes] = useState([]);
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
            nombre: '',
            cab_idcabezafamilia: '',
            cab_direccion: '',
            telefono: '',
            cab_celular: '',
            cab_correoelectronico: '',
            cab_nodeclaracion: ''
          });
	const { register, handleSubmit, reset, formState: { errors } } = useForm({
		defaultValues: {
			identificacion: '',
			observacion: ''
		}
	});

	const Mensaje = (title, text, icon = 'info') => {
		setSwalProps({
			show: true,
			title,
			text,
			icon,
		});
	};

	const handleFileChange = (event) => {
		const file = event.target.files?.[0] ?? null;
		setSelectedFile(file);
	};

	const resetForm = () => {
		reset();
		setSelectedFile(null);
		if (fileRef.current) {
			fileRef.current.value = '';
		}
	};

	const onSubmit = async (data) => {
		if (!selectedFile) {
			Mensaje('Cargar cédula', 'Seleccione un archivo antes de continuar.', 'warning');
			return;
		}

		const allowedTypes = ['application/pdf'];
		if (!allowedTypes.includes(selectedFile.type)) {
			Mensaje('Cargar cédula', 'Solo se permiten archivos PDF.', 'warning');
			return;
		}

		const maxSize = 5 * 1024 * 1024;
		if (selectedFile.size > maxSize) {
			Mensaje('Cargar cédula', 'El archivo no puede superar los 5 MB.', 'warning');
			return;
		}

		setCargando(true);
		try {
            const base64String = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(selectedFile);
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
            });
            const payload = {
                fileName: selectedFile.name,
                fileType: selectedFile.type,
                contentBase64: base64String,
                usrId: user,
                perIdPersona: data.identificacion,
                nombre: integrantes.find(i => i.per_idpersona === data.identificacion)?.nombre || '',
                IdCabezaFamilia: idCabezaFamilia,
                pdfDosHojas: data.pdfDosHojas || 'true'
            };
			const uploadUrl = '/archivo/registrarcargacedula';
			const response = await apiService.uploaddoc(uploadUrl, payload, token);
			if (response.status === 200) {
				Mensaje('Cargar cédula', response.data?.message + ' ' + (response.data?.nombre || '') || 'Archivo cargado correctamente.', 'success');
				resetForm();
			}
		} catch (error) {
			if (error.status === 422) {
				Mensaje('Cargar cédula', JSON.stringify(error.response.data.errors), 'error');
			} else if (error.status === 409) {
				Mensaje('Cargar cédula', JSON.stringify(error.response.data), 'error');
			} else {
				Mensaje('Cargar cédula', error.response?.data?.message || 'No fue posible cargar el archivo.', 'error');
			}
			console.error('Error uploading cedula:', error);
		} finally {
			setCargando(false);
		}
	};

    useEffect(() => {
        if (idCabezaFamilia) {
            const fetchData = async () => {
            const url = '/caracterizacion/crearformulariocargarcedula';
            const obj = { idCabezaFamilia: idCabezaFamilia };
            try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setCabezaFamiliaDatos(result.cabezafamilia);
                setIntegrantes(result.integrantes || []);

            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
        };
        fetchData();
        }
    }, [idCabezaFamilia, token]);
	return (
		<div className="content-wrapper">
			<section className="content-header">
				<div className="container-fluid">
					<div className="row mb-2">
						<div className="col-sm-6">
							<h1 className="m-0">Cargar c&eacute;dula</h1>
						</div>
						<div className="col-sm-6">
							<ol className="breadcrumb float-sm-right">
								<li className="breadcrumb-item"><NavLink to="/">Inicio</NavLink></li>
								<li className="breadcrumb-item"><NavLink to={"/caracterizacion/grupofamiliar/"+idCabezaFamilia}>Volver</NavLink></li>
								<li className="breadcrumb-item active">Cargar c&eacute;dula</li>
							</ol>
						</div>
					</div>
				</div>
			</section>

			<section className="content">
				<div className="container-fluid">
					{Cargando && (
						<div className="centered">
							<div><progress value={null} /></div>
						</div>
					)}
					<div className="row">
                        <DatosCabezaFamilia datos={CabezaFamiliaDatos} />
						<div className="col-md-12">
							<div className="card card-primary">
								<div className="card-header">
									<h3 className="card-title">Formulario de carga</h3>
								</div>
								<form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
									<div className="card-body">
										<div className="form-group row">
											<label htmlFor="identificacion" className="col-sm-3 col-form-label">Identificación</label>
											<div className="col-sm-9">
												<select
													id="identificacion"
													className="form-control"
													placeholder="Digite la identificación"
													{...register('identificacion', { required: true })}
												>
													<option value="">Seleccione una identificación</option>
													{integrantes.map((persona) => (
														<option key={persona.per_idpersona} value={persona.per_idpersona}>
															{persona.per_idpersona} - {persona.nombre}
														</option>
													))}
												</select>
												{errors.identificacion && <small className="text-danger">Ingrese la identificación.</small>}
											</div>
										</div>

										<div className="form-group row">
											<label htmlFor="archivo" className="col-sm-3 col-form-label">Archivo de c&eacute;dula</label>
											<div className="col-sm-9">
												<div className="input-group">
													<input
														ref={fileRef}
														id="archivo"
														type="file"
														className="d-none"
														accept=".pdf,application/pdf"
														onChange={handleFileChange}
													/>
													<label className="btn btn-outline-secondary" htmlFor="archivo">
														Seleccionar archivo
													</label>
													<div className="form-control bg-light">
														{selectedFile ? selectedFile.name : 'Ningún archivo seleccionado'}
													</div>
												</div>
												<small className="form-text text-muted">Solo PDF. Tama&ntilde;o m&aacute;ximo: 5 MB.</small>
											</div>
										</div>
                                        <div className="form-group row">
											<label htmlFor="pdfDosHojas" className="col-sm-3 col-form-label">¿El PDF tiene dos hojas?</label>
											<div className="col-sm-9">
												<select
													id="pdfDosHojas"
													className="form-control"
													type="text"
													placeholder="Seleccione una opción"
													{...register('pdfDosHojas', { required: true })}>
													<option value="true" defaultValue>SI</option>
													<option value="false">NO</option>
												</select>
												{errors.pdfDosHojas && <small className="text-danger">Seleccione si el PDF tiene dos hojas.</small>}
											</div>
										</div>
									</div>

									<div className="card-footer d-flex justify-content-end gap-2">
										<button type="submit" className="btn btn-primary" disabled={Cargando}>
											Subir archivo
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>

			<SweetAlert2
				{...swalProps}
				didClose={() => {
					setSwalProps({});
				}}
			/>
		</div>
	);
}
